import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ClientContext } from "../../context/Client/ClientContext";

const ClientCard = ({ client }) => {
  const navigate = useNavigate();
  const { selectedClient, setSelectedClient } = useContext(ClientContext);

  const baseImageUrl = process.env.REACT_APP_ROOT_IMAGES_PATH || "";

  const isSelected = selectedClient?.id === client.id;

  const handleClientCardClick = () => {
    setSelectedClient(client);
    navigate(`/client/${client.id}`);
  };

  const logoSrc =
    client.isLogo && client.imageName
      ? `${baseImageUrl}${client.clientId}/${client.imageName}`
      : "/images/noLogo2.png";

  return (
    <button
      type="button"
      className={`gog-client-result-card ${isSelected ? "active" : ""}`}
      onClick={handleClientCardClick}
    >
      <div className="gog-client-result-logo">
        <img src={logoSrc} alt={`${client.directoryName || "Client"} logo`} />
      </div>

      <div className="gog-client-result-info">
        <strong>{client.directoryName || "Unnamed Merchant"}</strong>

        {(client.address1 || client.address2) && (
          <span>
            {[client.address1, client.address2].filter(Boolean).join(" ")}
          </span>
        )}

        {(client.city || client.province) && (
          <small>
            {[client.city, client.province].filter(Boolean).join(", ")}
          </small>
        )}
      </div>

      <div className="gog-client-result-arrow">›</div>
    </button>
  );
};

export default ClientCard;